"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfMobile = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./base-driver"), exports);
tslib_1.__exportStar(require("./namespace-classes"), exports);
tslib_1.__exportStar(require("./render-comp-and-return-unmount"), exports);
tslib_1.__exportStar(require("./render-html.comp"), exports);
tslib_1.__exportStar(require("./get-runtime-custom-fields"), exports);
tslib_1.__exportStar(require("./local-translations"), exports);
exports.checkIfMobile = function () {
    try {
        return window.innerWidth < 768;
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=index.js.map